import type { FC } from 'react';
import React, { useState } from 'react';
import styled from 'styled-components';

import type { IMetapolicies } from './types';

import { getLabelOfCalculationType } from './utils';

import {
  formatCurrency,
  formatCurrencyWithName,
} from '../../utils/stringUtils';

const Metapolicies: FC<IMetapolicies> = ({
  metapolicies,
  isMobile,
  showLabels = true,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const shownMetapolicies = isCollapsed
    ? metapolicies.slice(0, 3)
    : metapolicies;

  return (
    <StyledWrapper>
      <StyledTitle $isMobile={isMobile}>Оплачивается на месте</StyledTitle>
      <StyledList $isMobile={isMobile}>
        {shownMetapolicies.map(
          ({
            name,
            price,
            currency,
            price_converted,
            calculation_type,
            id,
          }) => {
            const formattedCurrency = formatCurrencyWithName(price, currency);
            const label = showLabels
              ? getLabelOfCalculationType(calculation_type)
              : '';

            return (
              <li key={id}>
                {`${name} — `}
                {`${formattedCurrency}${label} `}
                {currency !== 'RUB' && (
                  <span>{`(${formatCurrency(price_converted)})`}</span>
                )}
              </li>
            );
          },
        )}
        {isCollapsed && metapolicies?.length > 3 ? (
          <StyledUncollapseText onClick={() => setIsCollapsed(false)}>
            Показать все
          </StyledUncollapseText>
        ) : null}
      </StyledList>
    </StyledWrapper>
  );
};

const StyledTitle = styled.h5<{ $isMobile?: boolean }>`
  margin: 0;
  color: var(--black);
  font-size: ${({ $isMobile }) => ($isMobile ? 16 : 14)}px;
  font-style: normal;
  font-weight: 500;
`;

const StyledList = styled.ul<{ $isMobile?: boolean }>`
  margin-top: 8px;
  margin-bottom: ${({ $isMobile }) => ($isMobile ? 16 : 0)}px;

  li {
    color: var(--black);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    margin-bottom: ${({ $isMobile }) => ($isMobile ? 8 : 4)}px;
  }
`;

const StyledWrapper = styled.div`
  margin-top: 16px;
`;

const StyledUncollapseText = styled.span`
  cursor: pointer;
  color: var(--secondary);
`;

export default Metapolicies;
